
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'Journalism',
  setup () {
    return {}
  }
})
